import { DropdownButton, DropdownToggle } from "./Dropdown";

export const DetailCard = ({ title, icon, children }) => (
    <div className="card border-0 shadow-sm rounded-4 mb-4">
        <div className="p-3">
            <h5 className="fw-semibold d-flex align-items-center gap-2">
                {icon} {title}
            </h5>
            <hr className="m-0" />
        </div>
        <div className="card-body">{children}</div>
    </div>
);

export const SortArrows = ({ field, sortBy, sort, onSort }) => (
    <div className="sort-arrow">
        <i className={sortBy === field && sort === false ? "i-active" : ""} onClick={() => onSort(field, false)}>▲</i>
        <i className={sortBy === field && sort === true ? "i-active" : ""} onClick={() => onSort(field, true)}>▼</i>
    </div>
);

export const parseFmtDateTime = (str) => {
    if (!str) return new Date(0);
    const [datePart, timePart, ampm] = str.split(" ");
    const [dd, mm, yyyy] = datePart.split("/").map(Number);
    let [hh, min] = (timePart || "00:00").split(":").map(Number);
    if (ampm === "PM" && hh !== 12) hh += 12;
    if (ampm === "AM" && hh === 12) hh = 0;
    return new Date(yyyy, mm - 1, dd, hh, min);
};

export const fmtDateTime = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(String(dateStr).replace(" ", "T"));
    if (isNaN(date.getTime())) return "";
    const pad = (n) => String(n).padStart(2, "0");
    let hours = date.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(hours)}:${pad(date.getMinutes())} ${ampm}`;
};

export const OptionDropdown = ({ label, options, active, onSelect }) => (
    <DropdownToggle label={<>{label} <i className="fa-solid fa-caret-down"></i></>}>
        {options.map((opt) => (
            <DropdownButton
                key={opt.value}
                label={opt.label}
                className={active === opt.value ? "active-option" : ""}
                onClick={() => onSelect(opt.value)}
            />
        ))}
    </DropdownToggle>
);

export const VerifiedBadge = () => (<>Verified <i className="fa-regular fa-circle-check success"></i></>)

export const ProofRow = ({ index, label, status, extra, photo, action }) => (
    <tr className="align-middle text-center">
        <td>{index}</td>
        <td>{label}</td>
        <td> <div>{status}</div> {extra ? <div>{extra}</div> : null} </td>
        <td>{photo}</td>
        <td>{action}</td>
    </tr>
);

export const ReactStyle = {
    control: (base, state) => ({ ...base, borderColor: state.isFocused ? "#f16436" : base.borderColor, boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none", "&:hover": { borderColor: "#f16436" }, }),
    option: (style, state) => ({ ...style, backgroundColor: state.isSelected ? "#f16436" : state.isFocused || state.isActive ? "#f164361a" : "white", color: state.isSelected ? "white" : "black", }),
};

export const stageStaff = (b, stage) => b?.stageHistory?.find((s) => s?.stage === stage)?.staffName || "-";

export const kycOf = (list, type) => (Array.isArray(list) ? list.find((k) => k?.type === type) : undefined);